module.exports = __webpack_public_path__ + "static/media/abis.1ac03be1.svg";